import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { getDefaultAuthenticatedRoute, isConsultantUser } from "../../utils/authRoles";

const ConsultantRouteGuard = ({ children }) => {
  const { user, isLoading } = useUser();

  if (isLoading) return null;
  if (isConsultantUser(user)) return children;

  return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
};

export default ConsultantRouteGuard;
